<template>
  <div>
    <div class="__inputfield3">
      <div class="col m-0 p-0">
        <button class="__blocksize2 m-0" type="button" name="button">
          <img src = "@/assets/image/instantprice/box LCL@3x.png">
          <p class="__title">Less than a <br> Containers (LCL)</p>
        </button>
      </div>
      <div
        v-for="(item, i) in form.loadsLCL"
        v-bind:key="i"
      >
        <div class="row pl-4 pr-4">
          <div class="__rightblock __customdropdown3">
            <p>Qty</p>
            <b-input-group class="__inputgroup">
              <b-form-input
                class="__form-input"
                type="number"
                placeholder=""
                v-model="item.qty"
                @keyup="calcUnit()"
              />
              <b-dropdown right text="Palletes" variant="" slot="append" :disabled="i > 0">
              <template slot="button-content">
                {{ item.type }}
              </template>
                <b-dropdown-item
                  @click="setType('Boxes')"
                >
                  <span>Boxes</span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="setType('Crates')"
                >
                  <span>Crates</span>
                </b-dropdown-item>
                <b-dropdown-item
                  @click="setType('Palletes')"
                >
                  <span>Palletes</span>
                </b-dropdown-item>
              </b-dropdown>
              <img class="__imgArrow" src = "@/assets/image/instantprice/right-arrow.svg">
            </b-input-group>
            <div v-if="error.loadsLCL" class="text-left input-group __input">
              <small class="text-danger" v-if="error.loadsLCL[i].qty && showError">Required</small>
            </div>
          </div>
          <div class="__weight">
            <p>Weight</p>
            <b-input-group
              class="__inputgroup2"
              append="Kg"
            >
              <b-form-input
                type="number"
                placeholder=""
                v-model="item.weight"
                @keyup="calcUnit()"
                @blur="checkError()"
              />
            </b-input-group>
            <div v-if="error.loadsLCL" class="text-left input-group __input">
              <small class="text-danger" v-if="error.loadsLCL[i].weight && showError">Required</small>
            </div>
          </div>
          <div class=" __size">
            <p>Volume</p>
            <b-input-group class="__inputgroup3" append="cm">
              <b-form-input
                type="number"
                placeholder="L"
                v-model="item.size.length"
                @keyup="calcUnit()"
              />
              <b-form-input
                type="number"
                placeholder="W"
                v-model="item.size.width"
                @keyup="calcUnit()"
              />
              <b-form-input
                type="number"
                placeholder="H"
                v-model="item.size.height"
                @keyup="calcUnit()"
              />
            </b-input-group>
            <div v-if="error.loadsLCL" class="text-left input-group __input">
              <small class="text-danger" v-if="(error.loadsLCL[i].size.length || error.loadsLCL[i].size.width || error.loadsLCL[i].size.height) && showError">Required</small>
            </div>
          </div>
          <div
            v-if="i === 0"
            class="__btnplus"
            @click="addContainer()"
          >
            <img src="@/assets/image/instantprice/Group 2626.png" alt="" />
          </div>
          <div
            v-else
            class="__btnremove"
            @click="removeContainer(i)"
          >
            <img src="@/assets/image/instantprice/buttonX.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-between _total__box_">
      <p>Total Shipment:</p>
      <p>{{ totalUnit }} {{ units }} / {{ totalWeight }} Kg / {{ totalCBM }} CBM</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LCL',
  props: {
    showError: Boolean
  },
  data () {
    return {
    // weight 20 => standard
    // 40 => overweight
      type: 'Ocean',
      totalUnit: 0,
      totalCBM: 0,
      totalWeight: 0,
      inputLoadsLCL: {
        id: 0,
        size: {
          length: '',
          width: '',
          height: '',
          unit: 'cbm'
        },
        qty: '',
        type: 'Palletes',
        weight: '',
        weightUnit: 'kg'
      },
      form: {
        typeObj: 'sub',
        loadsLCL: [{
          id: 0,
          size: {
            length: '',
            width: '',
            height: '',
            unit: 'cbm'
          },
          qty: '',
          type: 'Palletes',
          weight: '',
          volume: '',
          weightUnit: 'kg'
        }],
        totalUnit: 0,
        totalWeight: 0,
        lengthdimension: 0,
        widthdimension: 0,
        heightdimension: 0,
        totalVolumetric: 0,
        service_head: 'OCEAN',
        shipment_type: 'SEALCL',
        shipmentType: 'SEALCL'
      },
      errorData: {
        errorsLCL: false
      },
      error: {},
      units: 'Palletes'
    }
  },
  methods: {
    addContainer () {
      let arr = this.form.loadsLCL
      let i = arr.length + 1
      this.inputLoadsLCL.id = i

      arr.push({
        size: {
          length: '',
          width: '',
          height: '',
          unit: 'cbm'
        },
        qty: '',
        type: 'Palletes',
        weight: '',
        weightUnit: 'kg'
      })
      this.calcUnit()
      this.pushData()
    },
    removeContainer (index) {
      this.$delete(this.form.loadsLCL, index)
      this.calcUnit()
      this.pushData()
    },
    pushData () {
      this.$emit('IntantPriceData', this.form)
    },
    calcVM (size, cbm) {
      let vm = 1
      let volume = parseInt(size.length) * parseInt(size.width) * parseInt(size.height)

      vm = parseFloat(volume / cbm).toFixed(3)

      return !isNaN(vm) ? vm > 2.000 ? vm : 2.000 : 0
    },
    calcUnit () {
      let arr = this.form.loadsLCL
      const cbm = 1000000
      let totalCBM = arr.reduce((total, obj) => parseFloat(this.calcVM(obj.size ? obj.size : 0, cbm)) + parseFloat(total), 0).toFixed(3)
      this.totalUnit = arr.reduce((total, obj) => parseInt(obj.qty ? obj.qty : 0) + parseInt(total), 0)
      this.totalWeight = arr.reduce((total, obj) => (parseFloat(obj.weight ? obj.weight : 0) * parseInt(obj.qty ? obj.qty : 0)) + parseFloat(total), 0)
      this.form.loadsLCL[0].volume = Math.ceil(totalCBM)
      this.totalCBM = !isNaN(totalCBM) ? totalCBM : 0
      this.form.lengthdimension = this.form.loadsLCL[0].size.length
      this.form.widthdimension = this.form.loadsLCL[0].size.width
      this.form.heightdimension = this.form.loadsLCL[0].size.height
      this.form.totalVolumetric = totalCBM
      this.form.totalUnit = this.totalUnit
      this.form.totalWeight = this.totalWeight
      this.pushData()
      this.checkError()
    },
    setType (type) {
      let arr = this.form.loadsLCL
      arr.reduce((total, obj) => { obj.type = type }, {})
      this.inputLoadsLCL.type = type
      this.units = type
    },
    checkError () {
      let error = this.error
      const loadsArrayLCLErrors = []
      this.form.loadsLCL.forEach((load, loadIndex) => {
        const loadsErrors = { qty: null, weight: null, size: { length: null, width: null, height: null, unit: null } }
        if (!load.qty || load.qty < 1) {
          loadsErrors.qty = true
          loadsArrayLCLErrors[loadIndex] = loadsErrors
        }

        if (!load.weight || load.weight < 1) {
          loadsErrors.weight = true
          loadsArrayLCLErrors[loadIndex] = loadsErrors
        }

        if (!load.size.length || load.size.length < 1) {
          loadsErrors.size.length = true
          loadsArrayLCLErrors[loadIndex] = loadsErrors
        } else {
          loadsErrors.size.length = null
          loadsArrayLCLErrors[loadIndex] = loadsErrors
        }

        if (!load.size.width || load.size.width < 1) {
          loadsErrors.size.width = true
          loadsArrayLCLErrors[loadIndex] = loadsErrors
        } else {
          loadsErrors.size.width = null
          loadsArrayLCLErrors[loadIndex] = loadsErrors
        }

        if (!load.size.height || load.size.height < 1) {
          loadsErrors.size.height = true
          loadsArrayLCLErrors[loadIndex] = loadsErrors
        } else {
          loadsErrors.size.height = null
          loadsArrayLCLErrors[loadIndex] = loadsErrors
        }

        if (!loadsErrors.qty && !loadsErrors.weight && !loadsErrors.size.length && !loadsErrors.size.width && !loadsErrors.size.height) {
          this.errorData.errorsLCL = false
        } else {
          this.errorData.errorsLCL = true
        }
        return loadsErrors
      })
      if (loadsArrayLCLErrors.length) {
        error.loadsLCL = loadsArrayLCLErrors
      }

      this.$emit('errorInput', this.errorData)
    }
  },
  mounted () {
    this.calcUnit()
  },
  created () {
    this.pushData()
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/instantPrice/ShipmentType/LCL.vue